<script lang="ts" setup>
import { paginationLeftButton, paginationRightButton } from "~/utils/styles";

const { loggedIn } = useUserSession();

const { searchState, pagination } = useCatalog({
  initialize: {
    searchState: false,
    catalog: false,
    ssr: !loggedIn.value,
    scrollIntoViewThreshold: 500,
  },
});

const pageSizeOptions = computed(() => {
  return [
    { label: "15", value: 15 + pagination.value.pageSizeModifier },
    { label: "30", value: 30 + pagination.value.pageSizeModifier },
    { label: "45", value: 45 + pagination.value.pageSizeModifier },
  ];
});
</script>

<template>
  <div class="gap-md flex flex-col items-center lg:flex-row">
    <UPagination
      v-if="pagination.totalItems"
      v-model:page="searchState.page" :items-per-page="pagination.pageSize" :total="pagination.totalItems"
    >
      <template #prev>
        <UButton icon="i-ph-arrow-circle-left" :class="paginationLeftButton" />
      </template>

      <template #next>
        <UButton icon="i-ph-arrow-circle-right" :class="paginationRightButton" />
      </template>
    </UPagination>

    <USelectMenu
      v-model="searchState.pageSize" size="lg"
      :search-input="false" :items="pageSizeOptions" label-key="label" value-key="value"
      data-1p-ignore
    />
  </div>
</template>

<style scoped>

</style>
